import { render, staticRenderFns } from "./InfoAlert.vue?vue&type=template&id=9dd2d262&scoped=true&"
import script from "./InfoAlert.vue?vue&type=script&lang=js&"
export * from "./InfoAlert.vue?vue&type=script&lang=js&"
import style0 from "./InfoAlert.vue?vue&type=style&index=0&id=9dd2d262&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd2d262",
  null
  
)

export default component.exports